import React from 'react';
import OwnerDetailPresenterGeneral from './tabs/OwnerDetailPresenterGeneral';
import OwnerDetailPresenterRooms from './tabs/OwnerDetailPresenterRooms';
import OwnerDetailPresenterNotes from './tabs/OwnerDetailPresenterNotes';
import OwnerDetailPresenterHistory from './tabs/OwnerDetailPresenterHistory';
export default class OwnerDetailPresenterWorkspace extends React.Component {
  render() {
    return (
      <div className="tab-content">
        <OwnerDetailPresenterGeneral {...this.props} />
        <OwnerDetailPresenterRooms {...this.props} />
        <OwnerDetailPresenterNotes {...this.props} />
        <OwnerDetailPresenterHistory {...this.props} />
      </div>
    );
  }
}


